import * as React from "react";

import { t } from "@impero-com/common/utils/i18n";
import i18next from "i18next";
import memoizeOne from "memoize-one";

import { ControlCoveredPeriod } from "api/generated/model";
import { MultiSelectInput } from "components/form/legacyFields/multiSelectInput";
import { SelectInputOption } from "components/form/legacyFields/selectInput";
import {
    COVERED_PERIOD_VALUES,
    CoveredPeriodKey,
    coveredPeriodToKey,
    keyToCoveredPeriod,
    translateCoveredPeriod,
} from "utils/coveredPeriod";

import * as theme from "./theme.css";

const buildOptions = memoizeOne((_lang: string): Array<SelectInputOption> => {
    return Object.keys(COVERED_PERIOD_VALUES).map((keyStr) => {
        const key = keyStr as CoveredPeriodKey;
        return {
            value: key,
            label: translateCoveredPeriod(key),
        };
    });
});

interface PeriodWidgetProps {
    readOnly: "EDIT" | "READ_ONLY";
    initialValues: Array<ControlCoveredPeriod | null>;
    helpText?: string;
    onChange: (v: ControlCoveredPeriod | null) => void;
}

interface PeriodWidgetState {
    initialValues: Array<CoveredPeriodKey>;
}

class MultiPeriodInput extends React.PureComponent<
    PeriodWidgetProps,
    PeriodWidgetState
> {
    constructor(props: PeriodWidgetProps) {
        super(props);
        this.state = {
            initialValues: props.initialValues.map(coveredPeriodToKey),
        };
    }

    private onChangeInternal = (key: string | undefined) => {
        if (key !== undefined) {
            const { onChange } = this.props;
            const value = keyToCoveredPeriod(key as CoveredPeriodKey);
            onChange(value);
        }
    };

    render = (): React.ReactNode => {
        const { readOnly, helpText } = this.props;
        const { initialValues } = this.state;

        const options = buildOptions(i18next.language);
        const label = t("CreateControl_Control_CoveredPeriod");
        switch (readOnly) {
            case "EDIT":
                return (
                    <MultiSelectInput
                        type="EDIT"
                        label={label}
                        helpText={helpText}
                        name={label}
                        className={theme.wideMultiSelect}
                        values={initialValues}
                        options={options}
                        onChange={this.onChangeInternal}
                    />
                );
            case "READ_ONLY":
                return (
                    <MultiSelectInput
                        type="READ_ONLY"
                        label={label}
                        helpText={helpText}
                        name={label}
                        className={theme.wideMultiSelect}
                        values={initialValues}
                        options={options}
                        display={"Input"}
                    />
                );
        }
    };
}

export type { PeriodWidgetProps };
export { MultiPeriodInput };
